import { render, staticRenderFns } from "./FaviconUploader.vue?vue&type=template&id=62dc44be"
import script from "./FaviconUploader.vue?vue&type=script&lang=js"
export * from "./FaviconUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports